export const typography = {
  headings: {
    lineHeight: '1',
    fontWeight: 'bold',
    fontFamily: 'Arial, sans-serif',
    altHeadingFontFamily: '"Times New Roman", Times, Baskerville, Georgia',
    fontSize: '1.2rem'
  },
  body: {
    letterSpacing: '.025em',
    lineHeight: '1.3',
    fontFamily: 'Arial, sans-serif'
  },
  baseFontSize: '16px',
  sizes: {
    xsmall: '0.7rem',
    msmall: '0.8rem',
    small: '0.9rem',
    medium: '0.875rem',
    large: '1.2rem',
    larger: '1.5rem',
    xlarge: '1.8rem',
    xxlarge: '3rem'
  },
  lineHeight: {
    small: '1.2'
  }
}
export default typography
